/**
 * PrimaryButton Component
 * Encapsulated primary button with consistent styling
 */

import React from 'react';
import { Button, ButtonProps as MuiButtonProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export interface PrimaryButtonProps extends MuiButtonProps {
  // Inherits all MuiButton props
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({ 
  sx,
  variant = 'contained',
  ...props 
}) => {
  const theme = useTheme();
  
  const defaultStyles = {
    textTransform: 'none' as const,
    fontWeight: theme.typography.body1.fontWeight,
    padding: theme.spacing(1, 3),
    borderRadius: theme.shapes.borderRadius.md,
  };

  return (
    <Button
      variant={variant}
      sx={{
        ...defaultStyles,
        ...sx,
      }}
      {...props}
    />
  );
};

